import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import Pagination from 'components/Pagination';
import Search from 'components/Search';
import PoiList from 'components/PoiList';

import { makeAfter, withData } from 'lib';
import { ContentPoiListPageQuery } from '__generated__/ContentPoiListPageQuery.graphql';

const query = graphql`
  query ContentPoiListPageQuery($first: Int!) {
    ...PoiList_data @arguments(first: $first)
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<ContentPoiListPageQuery>;
};

const ContentPoiListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<ContentPoiListPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page
      breadcrumbs={[
        { link: '/content', name: 'Turinys' },
        { name: 'Lankytinos vietos' },
      ]}>
      <Search>
        <Pagination>
          <PoiList data={data} />
        </Pagination>
      </Search>
    </Page>
  );
};

export default withData<ContentPoiListPageQuery>({
  query,
  variables: ({ currentUser, searchParams }) => ({
    first: currentUser.itemsPerPage,
    after: makeAfter(
      Number(searchParams.get('page')) || 0,
      currentUser.itemsPerPage
    ),
  }),
})(ContentPoiListPage);
